import {http, onSuccess, onFail} from "./http";

export const clientEmailAllowedParseFile = (eventPassword, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return http.post(`/api/cp/event/${eventPassword}/allowedEmails/parseFile`, formData)
        .then(onSuccess, onFail);
}

export const clientEmailAllowedGet = (eventPassword) =>
    http.get(`/api/cp/event/${eventPassword}/allowedEmails`)
        .then(onSuccess, onFail);

export const clientEmailAllowedCreate = (eventPassword, emails) =>
    http.post(`/api/cp/event/${eventPassword}/allowedEmails`, {emails})
        .then(onSuccess, onFail);

export const clientEmailAllowedDelete = (eventPassword, email) =>
    http.delete(`/api/cp/event/${eventPassword}/allowedEmails`, {params: {email}})
        .then(onSuccess, onFail);
